import { render, staticRenderFns } from "./editSubbrand.vue?vue&type=template&id=56c8c430"
import script from "./editSubbrand.vue?vue&type=script&lang=js"
export * from "./editSubbrand.vue?vue&type=script&lang=js"
import style0 from "./editSubbrand.vue?vue&type=style&index=0&id=56c8c430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/src/oncheckbuild_FutureGAJDKUpgrade90d6697d/FL2FL3nodefinapp/subbrandtool/client/1.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VSpacer})
